module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"min5Chars":"The subject must have 5 or more letters"},"es":{"min5Chars":"El asunto debe tener 5 o mas letras"}}')
  delete Component.options._Ctor
}
